import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.List.IRequest;
type Response = Api.Core.DealerGroup.List.IResponse;
type Headers = Api.Core.DealerGroup.List.IHeaders;
const url = '/api/DealerManagement/DealerGroup';
export default async function dealerGroupListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
